module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays.037da72f.jpeg";